import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DistributionChartComponent from './Component';
import { CHART_TAIL_TYPES } from 'store/scenes/distributions/chart/enums';
import getDistributionFunctionsByType from 'calculators/distributions';

import { getDistributionsType, getDistributionsFormValues } from 'store/form/distributions/selectors';
import { getTailType } from 'store/scenes/distributions/chart/selectors';
import { setTailType } from 'store/scenes/distributions/chart/actions';

import { setCutoffs } from 'store/scenes/distributions/cutoffs/actions';
import { setBinomialAlpha } from 'store/scenes/distributions/binomialAlpha/action';

import { setLeftCutoff, setRightCutoff, setBLeftCutoff, setBRightCutoff, setLeftZScore, setRightZScore } from 'store/form/distributions/actions';

class DistributionChartContainer extends React.PureComponent {
  handleChartTailTypeChange = async event => {
    const newTailType = event.target.value;

    await this.props.setTailType(newTailType);
    await this.props.recalculateCutoffs(newTailType);
  };

  render () {
    return (
      <DistributionChartComponent
        tailType={this.props.tailType}
        typeDistribution={this.props.typeDistribution}
        onChartTailTypeChange={this.handleChartTailTypeChange}
      />
    );
  }
}

DistributionChartContainer.propTypes = {
  tailType: PropTypes.string.isRequired,
  setTailType: PropTypes.func.isRequired,
  recalculateCutoffs: PropTypes.func.isRequired,
  typeDistribution: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  tailType: getTailType(state),
  typeDistribution: getDistributionsType(state)
});

const mapDispatchToProps = {
  setTailType,
  recalculateCutoffs: newTailType => (dispatch, getState) => {

    // eslint-disable-next-line
    // TODO: try to move out very similar logic to one function
    // see this function and:
    // src/scenes/Distributions/DistributionForm/CiAlpha/shared.js
    // src/scenes/Distributions/DistributionForm/ZScoreFields/Container.js
    // src/scenes/Distributions/DistributionForm/CutoffsFields/Container.js

    const state = getState();
    const type = getDistributionsType(state);
    const fns = getDistributionFunctionsByType(type);
    const distributionFormValues = getDistributionsFormValues(state);
    const isNormalDistribution = type === 'normal';
    const isBinomialDistribution = type === 'binomial';

    // reverse alpha value if tail is center
    const preliminaryAlpha =
      newTailType === CHART_TAIL_TYPES.CENTER
        ? 1 - distributionFormValues.alpha
        : distributionFormValues.alpha;

    let alpha =
      newTailType === CHART_TAIL_TYPES.BOTH || newTailType === CHART_TAIL_TYPES.CENTER
        ? preliminaryAlpha / 2
        : preliminaryAlpha;

    const cutoffs = fns.getCutoffsByAlpha(distributionFormValues, alpha, newTailType);

    let zScoreLeft = -1;
    let zScoreRight = 1;

    // z score is available only for the normal distribution
    if (isNormalDistribution) {
      zScoreLeft = fns.getZScoreByCutoffValue(distributionFormValues, cutoffs.left.x);
      zScoreRight = fns.getZScoreByCutoffValue(distributionFormValues, cutoffs.right.x);
    }
    if (isBinomialDistribution) {
      alpha = fns.getAlphaByCutoffsAndTailType(distributionFormValues, cutoffs.left.x, cutoffs.right.x, newTailType);
      dispatch([
        setCutoffs(cutoffs),
        setBinomialAlpha(alpha),
        setBLeftCutoff(cutoffs.left.x),
        setBRightCutoff(cutoffs.right.x)
      ]);
    } else {
      dispatch([
        setCutoffs(cutoffs),
        setLeftCutoff(cutoffs.left.x),
        setRightCutoff(cutoffs.right.x),

        setLeftZScore(zScoreLeft),
        setRightZScore(zScoreRight)
      ]);
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(
  DistributionChartContainer
);
